import { useEffect } from 'react';
import { create } from 'zustand';

/** Nom de la page affichée, repris dans le titre de l'onglet du navigateur. */
export const usePageTitleStore = create<{ pageTitle: string | null; setPageTitle: (t: string | null) => void }>(
  (set) => ({ pageTitle: null, setPageTitle: (pageTitle) => set({ pageTitle }) }),
);

/** Donne un nom à l'onglet tant que la page est affichée. null : titre du cabinet seul. */
export function usePageTitle(title: string | null | undefined) {
  const setPageTitle = usePageTitleStore((s) => s.setPageTitle);
  useEffect(() => {
    setPageTitle(title?.trim() || null);
    return () => setPageTitle(null);
  }, [title, setPageTitle]);
}
